/* Hero Charm Bar — two jobs, both IntersectionObserver, no dependencies.
   1. Scroll reveal: fade the tiles up when they enter the viewport, staggered
      by their index inside the observer batch (100ms apart), which is what the
      Motion original did with setTimeout.
   2. Videos: play while in view, pause while out of view. Motion never paused,
      so two looping MP4s kept decoding for the whole page. */
if (!customElements.get('pr-hero-grid')) {
  customElements.define(
    'pr-hero-grid',
    class PrHeroGrid extends HTMLElement {
      connectedCallback() {
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (this.hasAttribute('data-hcb-reveal') && !reduced) {
          const items = this.querySelectorAll('.hcb__item');
          if (items.length) {
            this.revealObserver = new IntersectionObserver(
              (entries, observer) => {
                entries.forEach((entry, index) => {
                  if (!entry.isIntersecting) return;
                  entry.target.style.transitionDelay = `${index * 100}ms`;
                  entry.target.classList.add('is-revealed');
                  observer.unobserve(entry.target);
                });
              },
              { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
            );
            items.forEach((item) => this.revealObserver.observe(item));
          }
        }

        const videos = this.querySelectorAll('[data-hcb-video]');
        if (videos.length) {
          this.videoObserver = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  const playing = entry.target.play();
                  // Autoplay can be refused (data saver, low power mode). The
                  // first frame is still painted thanks to the #t=0.001 media
                  // fragment on the source; the class is only a CSS/diagnostic
                  // hook for whatever we may want to do about it later.
                  if (playing) {
                    playing
                      .then(() => entry.target.classList.remove('is-autoplay-blocked'))
                      .catch(() => entry.target.classList.add('is-autoplay-blocked'));
                  }
                } else {
                  entry.target.pause();
                }
              });
            },
            { threshold: 0.1 }
          );
          videos.forEach((video) => this.videoObserver.observe(video));
        }
      }

      disconnectedCallback() {
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.videoObserver) this.videoObserver.disconnect();
      }
    }
  );
}
